/* LIMBRANO — interacciones propias (vanilla, sin librerías) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    var fmt = (window.lbMoneyFormat || '{{amount_with_comma_separator}} €');
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withDots = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDots + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withDots)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + parts[1]);
  }

  /* ---------- Reveals al hacer scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.lb-reveal:not(.lb-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('lb-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('lb-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Parallax suave del hero ---------- */
  function initParallax() {
    var imgs = document.querySelectorAll('[data-lb-parallax]');
    if (!imgs.length || reduceMotion) return;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        var box = img.parentElement.getBoundingClientRect();
        if (box.bottom < 0 || box.top > window.innerHeight) return;
        var k = parseFloat(img.getAttribute('data-lb-parallax'));
        if (!k) { img.style.transform = ''; return; }
        var max = box.height * 0.055;
        var y = Math.max(-max, Math.min(max, box.top * -k));
        img.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Escena sticky del destacado ---------- */
  function initFeature() {
    document.querySelectorAll('[data-lb-feature]').forEach(function (root) {
      var steps = root.querySelectorAll('.lb-step');
      var imgs = root.querySelectorAll('.lb-feature__visual img');
      var counter = root.querySelector('.lb-feature__counter');
      if (!steps.length) return;
      function activate(i) {
        steps.forEach(function (s, j) { s.classList.toggle('is-active', i === j); });
        var target = steps[i].getAttribute('data-img');
        imgs.forEach(function (img) { img.classList.toggle('is-active', img.getAttribute('data-img') === target); });
        if (counter) counter.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(steps.length).padStart(2, '0');
      }
      activate(0);
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) activate(Array.prototype.indexOf.call(steps, e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) { io.observe(s); });
    });
  }

  /* ---------- Página de producto ---------- */
  function initPdp() {
    document.querySelectorAll('[data-lb-pdp]').forEach(function (root) {
      var dataEl = root.querySelector('[data-lb-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var idInput = root.querySelector('input[name="id"]');
      var groups = root.querySelectorAll('[data-lb-option]');
      var btnAdd = root.querySelector('[data-lb-add]');
      var btnNow = root.querySelector('[data-lb-now]');
      var errorEl = root.querySelector('.lb-buy__error');
      var qtyInput = root.querySelector('.lb-qty input');
      var priceNow = root.querySelectorAll('[data-lb-price]');
      var priceOld = root.querySelectorAll('[data-lb-compare]');
      var priceSave = root.querySelectorAll('[data-lb-save]');
      var track = root.querySelector('.lb-gallery__track');
      var slides = root.querySelectorAll('.lb-gallery__slide');
      var thumbs = root.querySelectorAll('.lb-thumb');
      var countEl = root.querySelector('.lb-gallery__count');
      var addText = btnAdd ? btnAdd.getAttribute('data-text') : '';
      var soldText = btnAdd ? btnAdd.getAttribute('data-sold') : '';

      /* Galería */
      function current() {
        if (!track) return 0;
        return Math.round(track.scrollLeft / track.clientWidth);
      }
      function goTo(i, smooth) {
        if (!track || !slides.length) return;
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false || reduceMotion ? 'auto' : 'smooth' });
        mark(i);
      }
      function mark(i) {
        thumbs.forEach(function (t, j) { t.classList.toggle('is-active', i === j); });
        if (countEl) countEl.textContent = (i + 1) + ' / ' + slides.length;
        var t = thumbs[i];
        if (t && t.parentElement) {
          var p = t.parentElement;
          if (p.scrollHeight > p.clientHeight) p.scrollTo({ top: t.offsetTop - p.clientHeight / 2 + t.clientHeight / 2, behavior: 'smooth' });
          if (p.scrollWidth > p.clientWidth) p.scrollTo({ left: t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
        }
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
      var prev = root.querySelector('.lb-gallery__nav--prev');
      var next = root.querySelector('.lb-gallery__nav--next');
      if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
      if (next) next.addEventListener('click', function () { goTo(current() + 1); });
      if (track) {
        var st;
        track.addEventListener('scroll', function () {
          clearTimeout(st);
          st = setTimeout(function () { mark(current()); }, 60);
        }, { passive: true });
      }

      function slideForVariant(v) {
        if (!slides.length) return -1;
        if (v.featured_media) {
          for (var i = 0; i < slides.length; i++) {
            if (slides[i].getAttribute('data-media-id') === String(v.featured_media.id)) return i;
          }
        }
        /* Si la variante no tiene foto propia, buscamos el color en el nombre de la foto */
        var colorIdx = parseInt(root.getAttribute('data-color-index'), 10);
        if (isNaN(colorIdx) || colorIdx < 0) return -1;
        var color = (v.options[colorIdx] || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().split(' ')[0];
        if (!color) return -1;
        for (var k = 0; k < slides.length; k++) {
          var src = (slides[k].getAttribute('data-src') || '').toUpperCase();
          if (src.indexOf(color) !== -1) return k;
        }
        return -1;
      }

      /* Variantes */
      function selected() {
        var vals = [];
        groups.forEach(function (g) {
          var c = g.querySelector('input:checked');
          vals.push(c ? c.value : null);
        });
        return vals;
      }
      function findVariant(vals) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          for (var j = 0; j < vals.length; j++) { if (v.options[j] !== vals[j]) { ok = false; break; } }
          if (ok) return v;
        }
        return null;
      }
      function refreshAvailability(vals) {
        groups.forEach(function (g, gi) {
          g.querySelectorAll('input').forEach(function (inp) {
            var test = vals.slice();
            test[gi] = inp.value;
            var v = findVariant(test);
            var pill = inp.nextElementSibling;
            if (pill) pill.classList.toggle('is-unavailable', !v || !v.available);
          });
        });
      }
      function setButtons(v) {
        [btnAdd, btnNow].forEach(function (b) { if (b) b.disabled = !v || !v.available; });
        if (btnAdd) btnAdd.querySelector('span').textContent = !v ? soldText : v.available ? addText : soldText;
        root.querySelectorAll('[data-lb-sticky-btn]').forEach(function (b) { b.disabled = !v || !v.available; });
      }
      function update(fromUser) {
        var vals = selected();
        var v = findVariant(vals);
        groups.forEach(function (g, gi) {
          var label = g.querySelector('[data-lb-current]');
          if (label) label.textContent = vals[gi] || '';
        });
        refreshAvailability(vals);
        setButtons(v);
        if (!v) return;
        if (idInput) idInput.value = v.id;
        priceNow.forEach(function (el) { el.textContent = money(v.price); });
        var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
        priceOld.forEach(function (el) { el.textContent = hasCompare ? money(v.compare_at_price) : ''; el.hidden = !hasCompare; });
        priceSave.forEach(function (el) {
          if (!hasCompare) { el.hidden = true; return; }
          el.hidden = false;
          var tpl = el.getAttribute('data-tpl') || 'Ahorras [amount]';
          el.textContent = tpl.replace('[amount]', money(v.compare_at_price - v.price))
            .replace('[percent]', Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%');
        });
        if (fromUser) {
          var i = slideForVariant(v);
          if (i > -1) goTo(i);
          if (window.history && history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            history.replaceState({}, '', url.toString());
          }
        }
      }
      groups.forEach(function (g) {
        g.addEventListener('change', function () { update(true); });
      });
      update(false);
      var first = findVariant(selected());
      if (first) { var fi = slideForVariant(first); if (fi > 0) goTo(fi, false); }

      /* Cantidad */
      root.querySelectorAll('[data-lb-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-lb-qty'), 10);
          qtyInput.value = Math.max(1, Math.min(99, n));
        });
      });

      /* Añadir al carrito */
      function add(goCheckout, btn) {
        if (!idInput) return;
        if (errorEl) errorEl.classList.remove('is-visible');
        btn.classList.add('is-loading');
        var drawer = document.querySelector('cart-drawer');
        var body = { id: idInput.value, quantity: parseInt(qtyInput ? qtyInput.value : 1, 10) || 1 };
        if (drawer && !goCheckout) {
          body.sections = 'cart-drawer,cart-icon-bubble';
          body.sections_url = window.location.pathname;
        }
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) {
              if (errorEl) { errorEl.textContent = res.description || res.message; errorEl.classList.add('is-visible'); }
              return;
            }
            if (goCheckout) { window.location.href = '/checkout'; return; }
            if (drawer && res.sections) {
              drawer.classList.remove('is-empty');
              drawer.renderContents(res);
            } else {
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            }
          })
          .catch(function () { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; })
          .finally(function () { btn.classList.remove('is-loading'); });
      }
      if (btnAdd) btnAdd.addEventListener('click', function (e) { e.preventDefault(); add(false, btnAdd); });
      if (btnNow) btnNow.addEventListener('click', function (e) { e.preventDefault(); add(true, btnNow); });
      var form = root.querySelector('form[action*="/cart/add"]');
      if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(false, btnAdd); });

      /* Barra fija de compra */
      var sticky = root.querySelector('.lb-sticky');
      if (sticky && btnAdd && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(btnAdd);
        sticky.querySelectorAll('[data-lb-sticky-btn]').forEach(function (b) {
          b.addEventListener('click', function () { add(false, b); });
        });
      }

      /* Guía de tallas */
      var modal = root.querySelector('.lb-modal');
      if (modal) {
        document.body.appendChild(modal);
        root.querySelectorAll('[data-lb-open-guide]').forEach(function (b) {
          b.addEventListener('click', function () { modal.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
        });
        function close() { modal.classList.remove('is-open'); document.body.style.overflow = ''; }
        modal.addEventListener('click', function (e) { if (e.target === modal || e.target.closest('.lb-modal__close')) close(); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      }

      /* Fecha estimada de entrega (días laborables) */
      var del = root.querySelector('[data-lb-delivery]');
      if (del) {
        var addBiz = function (d, n) {
          var r = new Date(d);
          while (n > 0) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0 && r.getDay() !== 6) n--; }
          return r;
        };
        var opts = { weekday: 'short', day: 'numeric', month: 'short' };
        var now = new Date();
        var a = addBiz(now, parseInt(del.getAttribute('data-min'), 10) || 3);
        var b = addBiz(now, parseInt(del.getAttribute('data-max'), 10) || 7);
        var out = del.querySelector('[data-lb-dates]');
        if (out) out.textContent = a.toLocaleDateString('es-ES', opts) + ' y el ' + b.toLocaleDateString('es-ES', opts);
      }
    });
  }

  function initAll() {
    initReveal();
    initParallax();
    initFeature();
    initPdp();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  /* Editor de Shopify: re-inicializar al añadir/editar secciones */
  document.addEventListener('shopify:section:load', function () { initReveal(); initParallax(); initFeature(); initPdp(); });
})();
